// DO NOT EDIT -- generated from fs/services/dx-objects/definedevents.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';

export namespace DefinedEventsPublic {

  export const ArchiveDefinedEventEndpoint = "/grpc/dx_objects.DefinedEventsPublic/ArchiveDefinedEvent";
  /**
   * Archive an existing defined event for an org.
   * Once archived, the defined event cannot be modified and will not show up in GetAllDefinedEvents unless explicitly requested.
   */
  export function ArchiveDefinedEvent(sender: (req: ArchiveDefinedEventRequest, endpoint: string) => Promise<ArchiveDefinedEventResponse>, req: ArchiveDefinedEventRequest): { promise: () => Promise<ArchiveDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveDefinedEventEndpoint),
      endpoint: ArchiveDefinedEventEndpoint
    };
  }

  export const ArchiveMultiDefinedEventsEndpoint = "/grpc/dx_objects.DefinedEventsPublic/ArchiveMultiDefinedEvents";
  /** Archives/unarchives multiple defined events */
  export function ArchiveMultiDefinedEvents(sender: (req: ArchiveMultiDefinedEventsRequest, endpoint: string) => Promise<ArchiveMultiDefinedEventsResponse>, req: ArchiveMultiDefinedEventsRequest): { promise: () => Promise<ArchiveMultiDefinedEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMultiDefinedEventsEndpoint),
      endpoint: ArchiveMultiDefinedEventsEndpoint
    };
  }

  export const GetAllDefinedEventsEndpoint = "/grpc/dx_objects.DefinedEventsPublic/GetAllDefinedEvents";
  /**
   * Get all current non-archived defined events for an org.
   * If desired, archived events can also be retrieved with the explicit request flag.
   */
  export function GetAllDefinedEvents(sender: (req: GetAllDefinedEventsRequest, endpoint: string) => Promise<GetAllDefinedEventsResponse>, req: GetAllDefinedEventsRequest): { promise: () => Promise<GetAllDefinedEventsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllDefinedEventsEndpoint),
      endpoint: GetAllDefinedEventsEndpoint
    };
  }

  export const GetDefinedEventEndpoint = "/grpc/dx_objects.DefinedEventsPublic/GetDefinedEvent";
  /** Get a specific defined event, at the current version. */
  export function GetDefinedEvent(sender: (req: GetDefinedEventRequest, endpoint: string) => Promise<GetDefinedEventResponse>, req: GetDefinedEventRequest): { promise: () => Promise<GetDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventEndpoint),
      endpoint: GetDefinedEventEndpoint
    };
  }

  export const SetDefinedEventEndpoint = "/grpc/dx_objects.DefinedEventsPublic/SetDefinedEvent";
  /** Add a new defined event or update an existing defined event. */
  export function SetDefinedEvent(sender: (req: SetDefinedEventRequest, endpoint: string) => Promise<SetDefinedEventResponse>, req: SetDefinedEventRequest): { promise: () => Promise<SetDefinedEventResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetDefinedEventEndpoint),
      endpoint: SetDefinedEventEndpoint
    };
  }

  export const GetDefinedEventAccessEndpoint = "/grpc/dx_objects.DefinedEventsPublic/GetDefinedEventAccess";
  export function GetDefinedEventAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventAccessEndpoint),
      endpoint: GetDefinedEventAccessEndpoint
    };
  }

  export const SilenceIssueEndpoint = "/grpc/dx_objects.DefinedEventsPublic/SilenceIssue";
  /** silences issues for a defined event */
  export function SilenceIssue(sender: (req: EventSilenceIssueRequest, endpoint: string) => Promise<EventSilenceIssueResponse>, req: EventSilenceIssueRequest): { promise: () => Promise<EventSilenceIssueResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SilenceIssueEndpoint),
      endpoint: SilenceIssueEndpoint
    };
  }

  export const UnSilenceIssueEndpoint = "/grpc/dx_objects.DefinedEventsPublic/UnSilenceIssue";
  /** silences an issue for a defined event */
  export function UnSilenceIssue(sender: (req: EventUnSilenceIssueRequest, endpoint: string) => Promise<EventUnSilenceIssueResponse>, req: EventUnSilenceIssueRequest): { promise: () => Promise<EventUnSilenceIssueResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnSilenceIssueEndpoint),
      endpoint: UnSilenceIssueEndpoint
    };
  }
}

export interface ArchiveDefinedEventRequest {
  orgId: string;
  definedEventId: string;
  archived: boolean;
}

export interface ArchiveDefinedEventResponse {
  definedEvent: DefinedEventDetail | null;
}

export interface ArchiveMultiDefinedEventsRequest {
  orgId: string;
  definedEventIds: string[];
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveMultiDefinedEventsResponse {
  definedEvents: DefinedEventDetail[];
}

export interface GetAllDefinedEventsRequest {
  orgId: string;
  /** If true, archived defined events will also be returned. */
  includeArchived: boolean;
}

export interface GetAllDefinedEventsResponse {
  definedEvents: DefinedEventDetail[];
  /** The limit of active events. If length of active (i.e. non archived) events are at or over limit, new events will not be allowed. */
  activeLimit: number;
}

export interface GetDefinedEventRequest {
  orgId: string;
  definedEventId: string;
}

export interface GetDefinedEventResponse {
  definedEvent: DefinedEventDetail | null;
}

export interface SetDefinedEventRequest {
  orgId: string;
  /**
   * Defined event to be created or updated.
   * If the id field is not set, an id will be generated and a defined event will be stored.
   */
  definedEvent: search_settings.DefinedEvent | null;
  /**
   * If set, writes the defined event metadata as well.
   * If not set, the preexisting defined event metadata remains.
   */
  definedEventMetadata: search_settings.DefinedEventMetadata | null;
  /**
   * If set, dedupes create requests containing the same idempotence key.
   * If idempotence key has already been handled, the existing entity will be returned instead of creating a new entity.
   * The idempotence key is only respected on create requests that let the server generate the entity id.
   * Note: This is best effort. Idempotence keys are kept around for three days but may be garbage collected sooner.
   */
  idempotenceKey: string;
}

export interface SetDefinedEventResponse {
  definedEvent: DefinedEventDetail | null;
}

export interface DefinedEventDetail {
  definedEvent: search_settings.DefinedEventRecord | null;
}

export interface DefinedEventIssueSilence {
  id: string;
  definedEventId: string;
  expiresAt: protobuf.timestamp | null;
}

export interface EventSilenceIssueRequest {
  orgId: string;
  definedEventId: string;
  expiresAt: protobuf.timestamp | null;
}

export interface EventSilenceIssueResponse {
  issueSilence: DefinedEventIssueSilence | null;
}

export interface EventUnSilenceIssueRequest {
  orgId: string;
  definedEventId: string;
  issueSilenceId: string;
}

export interface EventUnSilenceIssueResponse {
  issueSilenceId: string;
  definedEventId: string;
}
